import { render, staticRenderFns } from "./TemperatureSimpleTable.vue?vue&type=template&id=6d1ade41"
import script from "./TemperatureSimpleTable.vue?vue&type=script&lang=js"
export * from "./TemperatureSimpleTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports